"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TizenInfo = (function () {
    function TizenInfo(window) {
        this.window = window;
        var capabilities = this.window.tizen.systeminfo.getCapabilities();
        var productInfo = this.window.webapis.productinfo;
        this.deviceType = 'SmartTV';
        this.deviceBrand = 'Samsung';
        this.browserName = this.window.navigator.userAgent;
        this.browserVersion = this.window.navigator.userAgent;
        this.deviceModel = productInfo.getModel();
        this.deviceManufacturer = 'Samsung';
        this.operatingSystemName = capabilities.platformName;
        this.operatingSystemVersion = "Platform: " + capabilities.platformVersion + " | API: " + capabilities.nativeApiVersion + " | Web API: " + capabilities.webApiVersion;
        this.uniqueDeviceId = capabilities.duid;
        this.userFriendlyName = capabilities.platformName + " " + capabilities.profile;
        this.deviceVersion = capabilities.platformVersion;
    }
    return TizenInfo;
}());
exports.TizenInfo = TizenInfo;
